import { RootState } from "store";
import { StateCreator } from "zustand";

import { updateBrowserStatus } from "common/MetaActions";

import { Thread } from "models/inbox/inbox";
import { UploadedDocument } from "models/dashboard/dashboard";
import { MessagesAPI } from "api/messages";
import { FilesAPI } from "api/files";

export interface StatusSlice {
  unreadThreads: number;
  unhandledUploads: number;

  setUnreadThreadsStatus: (customerId: string) => Promise<Thread[]>;
  setUnhandledUploadsStatus: (
    customerId: string
  ) => Promise<UploadedDocument[]>;
  resetStatus: () => void;
}

export const createStatusSlice: StateCreator<
  RootState,
  [["zustand/devtools", never]],
  [],
  StatusSlice
> = (set, get) => ({
  unreadThreads: 0,
  unhandledUploads: 0,

  setUnreadThreadsStatus: async (customerId) => {
    try {
      const unreadThreads = await MessagesAPI.fetchThreads(customerId);
      updateBrowserStatus({
        unreadThreads: unreadThreads.body.length,
        unhandledUploads: get().status.unhandledUploads
      });
      set(
        ({ status }) => ({
          status: {
            ...status,
            unreadThreads: unreadThreads.body.length
          }
        }),
        false,
        "status/SET_UNREAD_THREADS_STATUS"
      );
      return unreadThreads.body as Thread[];
    } catch (error) {
      // Error already handled by errorHandlingPlugin
      return [];
    }
  },

  setUnhandledUploadsStatus: async (customerId) => {
    try {
      const unhandledUploads = await FilesAPI.fetchDocuments(customerId, get().user.permissions.isInternal);
      updateBrowserStatus({
        unreadThreads: get().status.unreadThreads,
        unhandledUploads: unhandledUploads.body.length
      });
      set(
        ({ status }) => ({
          status: {
            ...status,
            unhandledUploads: unhandledUploads.body.length
          }
        }),
        false,
        "status/SET_UNHANDLED_UPLOADS_STATUS"
      );
      return unhandledUploads.body as UploadedDocument[];
    } catch (error) {
      // Error already handled by errorHandlingPlugin
      return [];
    }
  },

  resetStatus: () => {
    updateBrowserStatus({
      unreadThreads: 0,
      unhandledUploads: 0
    });
    set(
      ({ status }) => ({
        status: {
          ...status,
          unreadThreads: 0,
          unhandledUploads: 0
        }
      }),
      false,
      "status/RESET_STATUS"
    );
  }
});
